import { render } from "./ReliabilityScore.vue?vue&type=template&id=57438bf5"
import script from "./ReliabilityScore.vue?vue&type=script&lang=js"
export * from "./ReliabilityScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__